import { createFileRoute } from "@tanstack/react-router";
import Bipolar1Vs2EssentialsPage from "@/pages/articles/Bipolar1Vs2EssentialsPage";
export const Route = createFileRoute(
  "/essential-facts-bipolar-1-vs-2-coral-springs",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Bipolar 1 vs 2 Facts | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Essential facts about bipolar 1 vs bipolar 2 disorder. Learn the differences, symptoms, and treatment options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Bipolar 1 vs 2 Facts | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Essential facts about bipolar 1 vs bipolar 2 disorder. Learn the differences, symptoms, and treatment options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/essential-facts-bipolar-1-vs-2-coral-springs",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/essential-facts-bipolar-1-vs-2-coral-springs",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <Bipolar1Vs2EssentialsPage />;
}
